import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";
import MenuHeader from "../component/menuHeader";
import { useRecoilState } from "recoil";
import { tokenState, userState, winds } from "../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function header({
  backgroundColorHome,
  backgroundColorCompetition,
  backgroundColorAthlete,
  backgroundColorCountries,
  navigation,
}) {
  const [token, setToken] = useRecoilState(tokenState);
  const [user, setUser] = useRecoilState(userState);
  const [dimen, setDimensions] = useRecoilState(winds);

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 1000);

    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  function Logout() {
    setToken("");
    setUser("");
    setTimeout(() => {
      navigation.navigate("Login");
    }, 100);
  }

  function debounce(fn, ms) {
    let timer;
    return (_) => {
      clearTimeout(timer);
      timer = setTimeout((_) => {
        timer = null;
        fn.apply(this, arguments);
      }, ms);
    };
  }

  return (
    width >= 1280 && (
      <View
        style={{
          height: dimen.height,
          minWidth: 250,
          maxWidth: 300,
          width: "20%",
          backgroundColor: "#2B6AB1",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            borderBottomWidth: 1,
            borderColor: "#FFFFFF",
            marginHorizontal: 10,
            paddingVertical: 10,
          }}
        >
          <Image
            resizeMode={"contain"}
            style={{ width: 89, height: 86 }}
            source={require("../img/logo4.png")}
          />
          <Text
            style={{
              fontSize: 20,
              fontFamily: "Prompt",
              color: "#FFFFFF",
              marginLeft: 10,
            }}
          >
            {"ASIAN ATHLETICS\nASSOCIATION"}
          </Text>
        </View>
        <View
          style={{
            borderBottomWidth: 1,
            borderBottomColor: "#FFFFFF",
            paddingVertical: 30,
            marginHorizontal: 10,
          }}
        >
          <MenuHeader
            onPress={() => {
              token.user !== undefined &&
                token.user.role == "Admin" &&
                navigation.navigate("Home");
              token.user !== undefined &&
                token.user.role == "User" &&
                navigation.navigate("HomeUser");
              token.user == undefined && navigation.navigate("HomeUser");
            }}
            Title="HOME"
            source={
              backgroundColorHome == "#FFFFFF"
                ? require("../img/home blue.png")
                : require("../img/home white.png")
            }
            style={{ width: 35, height: 28 }}
            backgroundColor={backgroundColorHome}
          />
          {token !== "" && (
            <View>
              <MenuHeader
                onPress={() => {
                  token.user !== undefined &&
                    token.user.role == "Admin" &&
                    navigation.navigate("Competition");
                  token.user !== undefined &&
                    token.user.role == "User" &&
                    navigation.navigate("CompetitionUser");
                }}
                Title="COMPETITIONS"
                source={
                  backgroundColorCompetition == "#FFFFFF"
                    ? require("../img/sc Blue.png")
                    : require("../img/sc White.png")
                }
                style={{ width: 29, height: 32 }}
                backgroundColor={backgroundColorCompetition}
              />
              <MenuHeader
                onPress={() => {
                  token.user !== undefined &&
                    token.user.role == "Admin" &&
                    navigation.navigate("Athlete");
                  token.user !== undefined &&
                    token.user.role == "User" &&
                    navigation.navigate("AthleteUser");
                }}
                Title="ATHLETE"
                source={
                  backgroundColorAthlete == "#FFFFFF"
                    ? require("../img/Person Blue.png")
                    : require("../img/Person White.png")
                }
                style={{ width: 39, height: 29 }}
                backgroundColor={backgroundColorAthlete}
              />
            </View>
          )}
          {token.user !== undefined && token.user.role == "Admin" && (
            <MenuHeader
              onPress={() => {
                navigation.navigate("Countries");
              }}
              Title="COUNTRIES"
              source={
                backgroundColorCountries == "#FFFFFF"
                  ? require("../img/world blue.png")
                  : require("../img/world white.png")
              }
              style={{ width: 43, height: 43 }}
              backgroundColor={backgroundColorCountries}
            />
          )}
        </View>
        {token !== "" ? (
          <View style={{ marginHorizontal: 10 }}>
            <MenuHeader
              onPress={Logout}
              Title="LOG OUT"
              source={require("../img/Exit White.png")}
              style={{ width: 39, height: 35 }}
            />
          </View>
        ) : (
          <View style={{ marginHorizontal: 10 }}>
            <MenuHeader
              onPress={() => {
                navigation.navigate("Login");
              }}
              Title="LOG IN"
              source={require("../img/In White.png")}
              style={{ width: 39, height: 35 }}
            />
          </View>
        )}
      </View>
    )
  );
}
